import { STAGE_META } from "@/lib/nav";

export function StageBadge({ stage, testid }) {
  const meta = STAGE_META[stage] || { label: stage, cls: "bg-slate-100 text-slate-700 border-slate-300" };
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-sm border text-xs font-medium ${meta.cls}`}
    >
      {meta.label}
    </span>
  );
}

export function PageHeader({ overline, title, actions, children }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-6 rise">
      <div>
        {overline && <div className="overline text-muted-foreground mb-1">{overline}</div>}
        <h1 className="font-head font-bold text-3xl lg:text-4xl tracking-tight text-foreground leading-none">
          {title}
        </h1>
        {children && <p className="text-sm text-muted-foreground mt-2 max-w-2xl">{children}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}

export function Field({ label, children }) {
  return (
    <div>
      <div className="overline text-muted-foreground mb-1.5">{label}</div>
      <div className="text-sm text-foreground">{children ?? "—"}</div>
    </div>
  );
}

export function EmptyState({ title, subtitle, action }) {
  return (
    <div className="border border-dashed border-border rounded-md p-12 text-center bg-card">
      <div className="font-head font-semibold text-lg text-foreground">{title}</div>
      {subtitle && <p className="text-sm text-muted-foreground mt-1 max-w-md mx-auto">{subtitle}</p>}
      {action && <div className="mt-4 flex justify-center">{action}</div>}
    </div>
  );
}
